import BetaRibbon from './BetaRibbon'

export default BetaRibbon;
